import { Inject, Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import { MenuRoutes } from "./menu-routes";
import { ENVIRONMENT } from "../../../core/token";

@Injectable()
export class AdminMenuConstants extends MenuRoutes {
	constructor(@Inject(ENVIRONMENT) protected environment, public translateService: TranslateService) {
		super([
			{
				icon: environment.cdnEndpoint + "assets/ic-tools.svg",
				icon_selected: environment.cdnEndpoint + "assets/ic-tools-selected.svg",
				route: "/private/admin-tools",
				translate: translateService.stream("menu-admin-array-translate.admin-tools"),
			},
			{
				icon: environment.cdnEndpoint + "assets/ic-admin-users.svg",
				icon_selected: environment.cdnEndpoint + "assets/ic-admin-users-selected.svg",
				route: "/private/admin-clients",
				translate: translateService.stream("menu-admin-array-translate.admin-clients"),
			},
			{
				icon: environment.cdnEndpoint + "assets/ic-sales.svg",
				icon_selected: environment.cdnEndpoint + "assets/ic-sales-selected.svg",
				route: "/private/admin-sales",
				translate: translateService.stream("menu-admin-array-translate.admin-sales"),
			},
			{
				icon: environment.cdnEndpoint + "assets/ic-users.svg",
				icon_selected: environment.cdnEndpoint + "assets/ic-users-selected.svg",
				route: "/private/assigned-licenses",
				translate: translateService.stream("menu-admin-array-translate.assigned-licenses"),
			},
			{
				icon: environment.cdnEndpoint + "assets/ic-users.svg",
				icon_selected: environment.cdnEndpoint + "assets/ic-users-selected.svg",
				route: "/private/clients-extra",
				translate: translateService.stream("menu-admin-array-translate.admin-clients-no-bought"),
			},
		]);
	}
}
